import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import { mapActions } from "vuex";

require("./assets/css/fonts/icomoon.css");
require("./assets/css/fonts/flag-icon-css/css/flag-icon.min.css");
require("./assets/css/login-register.css");
require("./assets/css/notification.css");
require("./assets/css/bootstrap.css");
require("./assets/css/bootstrap-extended.css");
require("./assets/css/app.css");
require("./assets/css/colors.css");
require("./assets/css/vertical-menu.css");
require("./assets/css/vertical-overlay-menu.css");
require("./assets/css/palette-gradient.css");
require("./assets/css/input-group.css");
require("./assets/css/flex.css");
require("./assets/css/styles.css"); // custom styles

//scripts in one folder
import * as jQuery from "jquery"; //"./assets/js/jquery.min.js";
window.$ = window.jQuery = jQuery;

import * as tether from "tether"; //import * as tether from  "./assets/js/tether.min.js";
window.Tether = tether;

require("./assets/js/bootstrap.min.js");
require("./assets/js/perfect-scrollbar.jquery.min.js");
require("./assets/js/unison.min.js");
require("./assets/js/blockUI.min.js");
require("./assets/js/jquery.matchHeight-min.js");
require("./assets/js/app-menu.js");
require("./assets/js/app.js");

import _ from "lodash";

import GChart from "vue-google-charts";
Vue.use(GChart);
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
import Notifications from "vue-notification";
Vue.use(Notifications);
import VueTouch from "vue-touch";
Vue.use(VueTouch, { name: "v-touch" });
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);
import VueMask from "v-mask";
Vue.use(VueMask);
import vSelect from "vue-select";
Vue.component("v-select", vSelect); //import 'vue-select/dist/vue-select.css';

import modalImg from "./components/modalImg";
Vue.component("modalImg", modalImg);
import modalEq from "./components/modalEq.vue";
Vue.component("modalEq", modalEq);
import ModalEqInfo from "./components/ModalEqInfo.vue";
Vue.component("ModalEqInfo", ModalEqInfo);
import ModalTaskInfo from "./components/ModalTaskInfo.vue";
Vue.component("ModalTaskInfo", ModalTaskInfo);
import ModalAppealInfo from "./components/ModalAppealInfo.vue";
Vue.component("ModalAppealInfo", ModalAppealInfo);
import modalExecutor from "./components/modalExecutors.vue";
Vue.component("modalExecutor", modalExecutor);
import ModalTaskCreate from "./components/ModalTaskCreate.vue";
Vue.component("ModalTaskCreate", ModalTaskCreate);
import QrCode from "./components/Camera.vue";
Vue.component("QrCode", QrCode);
import InfoErrors from "./components/modalErrors.vue";
Vue.component("InfoErrors", InfoErrors);
//import modalChat from './components/ModalChat'; Vue.component('modalChat',modalChat);

//import Chat from 'vue-beautiful-chat'; Vue.use(Chat); //

import VueModal from "vue2-modal";
Vue.use(VueModal);

Vue.config.productionTip = false;

window.axios = require("axios");
window.axios.defaults.baseURL =
  "https://http1c.modern-expo.info/BaseCRM/hs/WebModern";
//window.axios.defaults.timeout = 60000
window.axios.defaults.headers.common["Cache-Control"] = "no-cache";
window.axios.defaults.headers.post["Content-Type"] =
  "application/json; charset=utf-8";

const names = require("./locales/locales.json");
const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: names,
});

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: store.state.google_api,
    libraries: "places",
    region: "UA",
    language: "en",
  },
});

Vue.mixin({
  methods: {
    showNotification(gr, title, message, classCSS, duration = 10000) {
      this.$notify({
        group: gr,
        title: title,
        text: message,
        type: classCSS,
        duration: duration,
      });
    },
    isValid(some) {
      if (
        some != null &&
        some != undefined &&
        some != "" &&
        some != " " &&
        typeof some != "undefined"
      ) {
        return true;
      } else {
        return false;
      }
    },
    changeLanguage(lang) {
      this.$store.state.mapDashShow = false;

      localStorage.setItem("lang", lang);
      this.$i18n.locale = lang;
      this.$store.state.langMap = lang;
      this.$store.state.mapDashShow = true;

      //  session
      if (this.$store.getters.getUserToken != null) {
        this.makeQuery("/setLanguageUserInterface", {
          session: this.$store.getters.getUserToken,
          lenguage: lang,
        }).then((res) => {});
      }
    },
    addError(title, text) {
      console.log(title + " / " + text);
      this.$store.commit("addError", { title: title, text: text });
    },
    showErrors() {
      this.$modals.show("InfoErrors");
      //this.$refs.InfoError.firstRun();
    },
    makeQuery(stringQuery, jsonData, baseurl = null, headers = {}) {
      if (baseurl == null) {
        baseurl = "https://http1c.modern-expo.info/BaseCRM/hs/WebModern";
      }
      this.$store.state.isLoading = true;
      this.$store.state.queries.push(true);

      return new Promise((resolve, reject) => {
        this.checkAuthorized();

        axios
          .post(baseurl + stringQuery, jsonData, { headers: headers })
          .then((response) => {
            this.$store.state.queries.splice(0, 1);
            if (this.$store.state.queries.length < 1) {
              this.$store.state.isLoading = false;
            }

            if (
              stringQuery == "/drawing/loginDraw" ||
              stringQuery == "/drawing/getDataProfile" ||
              stringQuery == "/drawing/saveProfile" ||
              stringQuery == "/setLanguageUserInterface"
            ) {
              if (typeof response.data == "string") {
                if (response.data.result == "Истина") {
                  return resolve(response);
                } else {
                  this.showNotification(
                    "custom-error",
                    "Error",
                    "Contact IT(1C) department"
                  );
                  this.addError("makeQuery", response.data.result);
                }
              } else {
                return resolve(response);
              }
            } else {
              if (response.data && response.data.result == true) {
                //if(response.data.data == null){ return resolve(true); }
                return resolve(response.data.data);
              } else {
                this.addError(
                  "makeQuery",
                  stringQuery + " / " + response.data.data
                );
                return reject(response.data.data);
              }
            }
          })
          .catch((error) => {
            this.$store.state.queries.splice(0, 1);
            if (this.$store.state.queries.length < 1) {
              this.$store.state.isLoading = false;
            }

            this.addError("makeQuery", error);

            if (
              error.response &&
              error.response.status &&
              error.response.status == 401
            ) {
              localStorage.removeItem("guidClient");
              localStorage.removeItem("user-token");
              localStorage.removeItem("userGuid");
              this.showNotification(
                "custom-error",
                "Error",
                this.$t("errors.500")
              );
              this.$router.push({ name: "login" });
            } else {
              return reject(error);
            }
          });
      });
    },
    makeQuery2(
      stringQuery,
      jsonData,
      baseurl = null,
      headers = {},
      method = "post"
    ) {
      if (baseurl == null) {
        baseurl = "https://http1c.modern-expo.info/BaseCRM/hs/WebModern";
      }
      this.$store.state.isLoading = true;
      this.$store.state.queries.push(true);

      let requestData = {
        url: baseurl + stringQuery,
        method: method,
        data: jsonData,
        headers: headers,
      };

      if (method === "get") {
        delete requestData.data;
      }

      return new Promise((resolve, reject) => {
        this.checkAuthorized();

        axios(requestData)
          .then((response) => {
            this.$store.state.queries.splice(0, 1);
            if (this.$store.state.queries.length < 1) {
              this.$store.state.isLoading = false;
            }

            if (response) {
              return resolve(response);
            } else {
              this.showNotification(
                "custom-error",
                "Error",
                "Contact IT(1C) department"
              );
              this.addError("makeQuery", response);
              return reject(response);
            }
          })
          .catch((error) => {
            this.$store.state.queries.splice(0, 1);
            if (this.$store.state.queries.length < 1) {
              this.$store.state.isLoading = false;
            }

            this.addError("makeQuery", error);

            if (
              error.response &&
              error.response.status &&
              error.response.status == 401
            ) {
              localStorage.removeItem("guidClient");
              localStorage.removeItem("user-token");
              localStorage.removeItem("userGuid");
              this.showNotification(
                "custom-error",
                "Error",
                this.$t("errors.500")
              );
              this.$router.push({ name: "login" });
            } else {
              return reject(error);
            }
          });
      });
    },
    query(url, jsonData, headers = {}) {
      this.$store.state.isLoading = true;
      this.$store.state.queries.push(true);

      return new Promise((resolve, reject) => {
        axios
          .post(url, jsonData, { headers: headers })
          .then((response) => {
            this.$store.state.queries.splice(0, 1);
            if (this.$store.state.queries.length < 1) {
              this.$store.state.isLoading = false;
            }

            if (response.data.result != null) {
              if (response.data.result == true) {
                return resolve(response.data.data);
              } else {
                return reject(response.data.data);
              }
            } else {
              return resolve(response.data);
            }
          })
          .catch((error) => {
            this.$store.state.queries.splice(0, 1);
            if (this.$store.state.queries.length < 1) {
              this.$store.state.isLoading = false;
            }

            return reject(error);
          });
      });
    },
    anchorTo(nameCont) {
      let self = this;
      setTimeout(function () {
        var element = self.$refs[nameCont];
        var top = element.offsetTop;
        window.scrollTo(0, top);
      }, 200);
      //$('html, body').animate({scrollTop: 0}, 600);//scroll to top
    },
    checkAuthorized: function () {
      return new Promise((resolve, reject) => {
        if (
          this.$store.getters.getUserToken == null &&
          (this.$route.name == "dashboard" ||
            this.$route.name == "profile" ||
            this.$route.name == "users" ||
            this.$route.name == "tasks" ||
            this.$route.name == "equipment" ||
            this.$route.name == "report" ||
            this.$route.name == "reglamentTask" ||
            this.$route.name == "appeals" ||
            this.$route.name == "history" ||
            this.$route.name == "activation")
        ) {
          console.log("checking LocalStorage");
          this.checkLS();

          if (
            this.$store.getters.getUserToken == null &&
            (this.$route.name == "dashboard" ||
              this.$route.name == "profile" ||
              this.$route.name == "users" ||
              this.$route.name == "tasks" ||
              this.$route.name == "equipment" ||
              this.$route.name == "report" ||
              this.$route.name == "reglamentTask" ||
              this.$route.name == "appeals" ||
              this.$route.name == "history" ||
              this.$route.name == "activation")
          ) {
            console.log("no data in LocalStorage, redirect to auth page");
            this.clearUserInfo();
            this.$router.push({ name: "login" });
            return reject("not authorized");
          }
        }
        return resolve();
      });
    },
    checkLS() {
      if (localStorage.getItem("userGuid") != null) {
        this.$store.commit("setGuidUser", localStorage.getItem("userGuid"));
      }
      if (localStorage.getItem("user-token") != null) {
        this.$store.commit("setUserToken", localStorage.getItem("user-token"));
      }
      if (localStorage.getItem("user") != null) {
        this.$store.state.user = localStorage.getItem("user");
      }
      if (localStorage.getItem("name") != null) {
        this.$store.state.userName = localStorage.getItem("name");
      }
      if (localStorage.getItem("username") != null) {
        this.$store.state.login = localStorage.getItem("username");
      }
      if (localStorage.getItem("email") != null) {
        this.$store.state.email = localStorage.getItem("email");
      }

      if (localStorage.getItem("ip") != null) {
        this.$store.state.ip = localStorage.getItem("ip");
      }
      if (localStorage.getItem("clientName") != null) {
        this.$store.state.clientName = localStorage.getItem("clientName");
      }
      if (localStorage.getItem("clientEdrpo") != null) {
        this.$store.state.clientEdrpo = localStorage.getItem("clientEdrpo");
      }
      if (localStorage.getItem("guidClient") != null) {
        this.$store.state.guidClient = localStorage.getItem("guidClient");
      }

      if (localStorage.getItem("profileImg") != null) {
        this.$store.commit(
          "setProfilePhoto",
          localStorage.getItem("profileImg")
        );
      }

      if (localStorage.getItem("role") != null) {
        let arrRoles = localStorage.getItem("role");
        if (arrRoles.indexOf("dispatcher") > -1) {
          this.$store.commit("setDispatcher", true);
        }
        if (arrRoles.indexOf("admin") > -1) {
          this.$store.commit("setAdmin", true);
        }
        if (arrRoles.indexOf("client") > -1) {
          this.$store.commit("setClient", true);
        }
        if (arrRoles.indexOf("service") > -1) {
          this.$store.commit("setService", true);
        }
        if (arrRoles.indexOf("serviceOrg") > -1) {
          this.$store.commit("setServiceOrg", true);
        }
        if (arrRoles.indexOf("user") > -1) {
          this.$store.commit("setUser", true);
        }
        if (arrRoles.indexOf("roleCourier") > -1) {
          this.$store.commit("setRoleCourier", true);
        }
      }
    },
    clearUserInfo() {
      window.localStorage.clear();

      localStorage.setItem("lang", this.$i18n.locale);

      this.$store.state.profilePhoto = require("./assets/pictures/profile.png");
      this.$store.commit("setGuidUser", null);
      this.$store.commit("setUserToken", null);
      this.$store.state.nameUser = null;
      this.$store.state.name = null;
      this.$store.state.user = null;
      this.$store.state.email = null;
      this.$store.state.guidClient = null;
      this.$store.state.clientName = null;
      this.$store.state.clientEdrpo = null;
      this.$store.state.ip = null;

      this.$store.commit("setDispatcher", false);
      this.$store.commit("setAdmin", false);
      this.$store.commit("setClient", false);
      this.$store.commit("setService", false);
      this.$store.commit("setServiceOrg", false);
      this.$store.commit("setUser", true);
      this.$store.commit("setRoleCourier", false);
    },
    dtTZ(dt) {
      if (dt != null && dt != "" && dt.indexOf("T") > -1) {
        let arr = dt.split("T");
        /*if(arr[1].indexOf('Z') > -1){
            let t = arr[1].split('Z');
            return arr[0] + ' ' + t[0];
          } else {
            return arr[0] + ' ' + arr[1];
          }*/
        return arr[0] + " " + arr[1];
      } else {
        return dt;
      }
    },
    convertDateForIos(date) {
      if (typeof date == "string") {
        let arr = date.split(/[- :]/);
        date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
        return date;
      } else {
        return date;
      }
    },
    dtFormat(dt) {
      if (dt != "" && dt != null) {
        let d = null;

        if (typeof dt == "string") {
          if (dt.indexOf("T") > -1) {
            let arr = dt.split("T");
            let dataT = arr[0] + " " + arr[1];
            d = this.convertDateForIos(dataT);
          } else {
            d = this.convertDateForIos(dt);
          }

          let dtn = +this.convertDateForIos(d);
          if (dtn < 0) {
            return null;
          }
        } else if (typeof dt == "number") {
          d = new Date(dt);
        } else {
          d = new Date(dt);
        }

        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        let day = d.getDate();
        let hours = d.getHours();
        let min = d.getMinutes();
        let sec = d.getSeconds();
        if (day < 10) {
          day = "0" + day;
        }
        if (month < 10) {
          month = "0" + month;
        }
        if (hours < 10) {
          hours = "0" + hours;
        }
        if (min < 10) {
          min = "0" + min;
        }
        if (sec < 10) {
          sec = "0" + sec;
        }

        if (hours == "00" && min == "00") {
          return day + "." + month + "." + year;
        }

        return (
          day + "." + month + "." + year + " " + hours + ":" + min + ":" + sec
        );
      } else {
        return dt;
      }
    },
    openURL(str) {
      window.open(str);
    },
    //geoposition
    getGPS: function () {
      let position = { latitude: null, longitude: null, accuracy: null };
      this.$store.state.isGPS = true;
      this.$store.state.queueGeo.push(true);

      let self = this;

      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            let crd = pos.coords;
            position.latitude = crd.latitude;
            position.longitude = crd.longitude;
            position.accuracy = crd.accuracy; //meters

            self.$store.state.queueGeo.splice(0, 1);
            if (self.$store.state.queueGeo.length < 1) {
              self.$store.state.isGPS = false;
            }

            return resolve(position);
          },
          function (err) {
            self.$store.state.queueGeo.splice(0, 1);
            if (self.$store.state.queueGeo.length < 1) {
              self.$store.state.isGPS = false;
            }
            return reject(err);
          },
          { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
        );
      });
    },
    getIcon(file) {
      if (file.indexOf(".xlsx") > -1 || file.indexOf(".xls") > -1) {
        return this.$store.state.iconsFiles.excell;
      } else if (file.indexOf(".txt") > -1 || file.indexOf(".xml") > -1) {
        return this.$store.state.iconsFiles.text;
      } else if (
        file.indexOf(".png") > -1 ||
        file.indexOf(".jpg") > -1 ||
        file.indexOf(".jpeg") > -1 ||
        file.indexOf(".png") > -1
      ) {
        return this.$store.state.iconsFiles.img;
      } else if (file.indexOf(".pdf") > -1) {
        return this.$store.state.iconsFiles.pdf;
      } else if (file.indexOf(".doc") > -1 || file.indexOf(".docx") > -1) {
        return this.$store.state.iconsFiles.word;
      } else if (
        file.indexOf(".zip") > -1 ||
        file.indexOf(".gz") > -1 ||
        file.indexOf(".rar") > -1 ||
        file.indexOf(".tar") > -1
      ) {
        return this.$store.state.iconsFiles.archive;
      } else if (file.indexOf(".ppt") > -1 || file.indexOf(".pptx") > -1) {
        return this.$store.state.iconsFiles.powerpoint;
      } else if (file.indexOf(".vsd") > -1) {
        return this.$store.state.iconsFiles.visio;
      }
    },
    showModalQR(address = null) {
      this.$store.state.active_qr = true;
      //this.$refs.QrCode.changeForm();
      this.$modals.show("QrCode");
    },
    getCoords: function (address) {
      return new Promise((resolve, reject) => {
        address = address.replace(" ", "%20");

        fetch(
          "https://maps.googleapis.com/maps/api/geocode/json?address=" +
            address +
            "&key=" +
            store.state.google_api
        )
          .then((response) => response.json())
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => {
            console.log(error);
            this.addError("getCoords", error);
            if (!_.isNil(error.response)) {
              this.showNotification("custom-error", "Error", error);
            }
          });
      });
    },
    fullscr() {
      var doc = window.document;
      var docEl = doc.documentElement;

      var requestFullScreen =
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen;
      var cancelFullScreen =
        doc.exitFullscreen ||
        doc.mozCancelFullScreen ||
        doc.webkitExitFullscreen;

      if (
        !doc.fullscreenElement &&
        !doc.mozFullScreenElement &&
        !doc.webkitFullscreenElement
      ) {
        requestFullScreen.call(docEl);
      } else {
        cancelFullScreen.call(doc);
      }
    },
    croppImg(data) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.onload = function () {
          var w = img.width;
          var h = img.height;
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d"); // Создаем узел атрибута
          var anw = document.createAttribute("width");
          anw.nodeValue = w;
          var anh = document.createAttribute("height");
          anh.nodeValue = h;
          canvas.setAttributeNode(anw);
          canvas.setAttributeNode(anh);
          ctx.drawImage(img, 0, 0, w, h);

          if (img.width > 1500) {
            var base64Img = canvas.toDataURL("image/jpeg", 0.6);
            return resolve(base64Img);
          } else {
            return resolve(img.src);
          }
        };
        img.src = data;
      });
    },
    getGuarrantee(date) {
      let guarantee = false;
      if (date != null && date != "") {
        let dt_now = new Date();
        date = +new Date(date);

        let days_diff = Math.ceil(Math.abs(dt_now - date) / (1000 * 3600 * 24));
        if (days_diff < 365) {
          guarantee = true;
        }
      }
      return guarantee;
    },
    convertImgUrlToBase64(url) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.setAttribute("crossorigin", "anonymous");
        img.src = url;
        img.onload = function () {
          var w = img.width;
          var h = img.height;
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d"); // Создаем узел атрибута
          var anw = document.createAttribute("width");
          anw.nodeValue = w;
          var anh = document.createAttribute("height");
          anh.nodeValue = h;
          canvas.setAttributeNode(anw);
          canvas.setAttributeNode(anh);
          ctx.drawImage(img, 0, 0, w, h);

          let ress = canvas.toDataURL("image/jpeg");
          canvas = null;

          return resolve(ress);
        };
        img.onerror = (error) => {
          console.log(
            "Could not load image, please check that the file is accessible and an image!",
            error
          );
        };

        /*
        var request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.responseType = 'blob';
        request.onload = function(){
            var reader = new FileReader();
            reader.readAsDataURL(request.response);
            reader.onload =  function(e){ return resolve( e.target.result); };
        };
        request.send();
*/
      });
    },
    checkPattSer(str) {
      if (str.includes("-")) {
        if (str.includes("me-")) {
          str = str.replace("me-", "ме-");
          return str;
        } else if (str.includes("se-")) {
          return str;
        } else if (str.includes("ме-")) {
          return str;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
});

Vue.config.devtools = true;

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: (h) => h(App),
  methods: {},
  mounted() {
    if (localStorage.getItem("lang")) {
      this.$i18n.locale = localStorage.getItem("lang");
    }
  },
  created() {
    this.checkAuthorized().then((result) => {});
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = to.meta.title || "Modern-Expo";
      },
    },
  },
});



// WEBPACK FOOTER //
// ./src/main.js